import type { TrackProperties } from '@openpanel/web';
import { hashPii } from '../hashPii/hashPii';
import { track } from '../track';

/**
 * Tracks an event whose properties include personal data (HB-1296).
 *
 * Every value in `piiProps` is hashed with `hashPii` before the event is sent;
 * `props` are sent as they are. A personal value that is empty or cannot be
 * hashed is left off the event rather than sent in plain text.
 */
export const trackHashed = async (
	event: string,
	piiProps: Record<string, string | null | undefined>,
	props?: TrackProperties
): Promise<void> => {
	const hashedEntries = await Promise.all(
		Object.entries(piiProps).map(async ([key, value]) => [key, await hashPii(value)] as const)
	);

	track(event, {
		...(props || {}),
		...Object.fromEntries(hashedEntries.filter(([, hash]) => hash !== undefined))
	});
};
